<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { ControlsContainer, Text, LabelListV2 } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Components
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	const _device = device;
	let statusToggle: VCInterfaceStatus;
	$: statusToggle = statuses.find((i) => /^(state)$/.test(i.role));
</script>

<div class="lable-list-wrapper-in-drawer-tab-content mb-s">
	<LabelListV2
		class="mb-l justify-content-center"
		size="m"
		backgroundColor="--color-1"
		data-prevent-drawer-swipe
		data-prevent-sidepanel-swipe
		a11yProps={{ isInteractive: true }}
		labelList={statuses.filter((i) => !/^(state)$/.test(i.role) || i?.sensor)}
		on:label-click={(e) => {
			e.stopPropagation();
		}}
	/>
</div>
<DeviceNotificationLabel deviceId={device?.id} />
<div class="flex-full-height justify-content-end">
	<ControlsContainer class="mt-s" color="color-0">
		<svelte:fragment slot="first">
			<VirtualBooleanButton
				isWide
				device={_device}
				componentID={statusToggle?.id}
				value={statusToggle?.event}
				useV2Components
				deviceButtonV2Props={{ size: 'l' }}
			/>
			<Text styleType="controls-large" class="mt-s text-bold"
				>{capFirstChar(
					statusToggle?.event
						? $format('label_action_turn_off', { default: 'turn off' })
						: $format('label_action_turn_on', { default: 'turn on' }),
				)}</Text
			>
		</svelte:fragment>
	</ControlsContainer>
</div>
